//--------------------------------------------------
// 赛事展示中的球队场景（默认队名、队徽等）
//--------------------------------------------------
const Live = require('@/tbs/model/to/Live')
const ClassFunc = require('@/tbs/util/ClassFunc')

const tbs_model_to_MatchTeam = function () {
  ClassFunc.super(this, Live, arguments)
}

tbs_model_to_MatchTeam.prototype = {
  'team-name-default': '待定',
  'team-logo-default': 'FgHxIubyIzCFletYKVbOEarVGsyx',
}

ClassFunc.extend(tbs_model_to_MatchTeam, Live)

module.exports = tbs_model_to_MatchTeam
